import script from "./ProfileEditPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileEditPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileEditPage.vue?vue&type=style&index=0&id=4e3c3d0f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e3c3d0f"]])

export default __exports__